module.exports = __webpack_public_path__ + "img/signup-bg@2x.a3a1e5f8.jpg";